/*
 * @author: chenshoyu
 * @Date: 2021-11-17 17:46:16
 */
/**
 * 搜索框组件状态定义与同步
 * @author VenDream
 * @since 17/11/20
 */

import { getUrlWithHttpsProtocol } from '@fe/common/lib/url';
import ACTIONS from 'constants/action.json5';

const initialState = {
  mainfigure: '',
  category: 'SEARCH',
  keywords: '',
  hotwords: [],
  searchFilterList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_MAIN_FIGURE: {
      return {
        ...state,
        mainfigure: getUrlWithHttpsProtocol(action.mainfigure),
      };
    }
    case ACTIONS.SET_SEARCH_KEYWORDS: {
      return { ...state, keywords: action.keywords };
    }
    case ACTIONS.SET_SEARCH_HOTWORDS: {
      return { ...state, hotwords: action.hotwords };
    }
    case ACTIONS.SET_SEARCH_CATEGORY: {
      return { ...state, category: action.category };
    }
    case ACTIONS.ADD_SEARCH_FILTER: {
      //reduce里面不能直接修改原始的state，直接修改组件不会重新渲染
      let targetArr = state.searchFilterList.concat();
      let isTwice = false;
      if (targetArr.length > 0) {
        for (let index = 0; index < targetArr.length; index++) {
          const element = targetArr[index];
          if (element.key === action.filter[0].key) {
            targetArr.splice(index, 1, action.filter[0]);
            isTwice = true;
          }
        }
        if (!isTwice) {
          targetArr = targetArr.concat(action.filter);
        }
      } else {
        targetArr = targetArr.concat(action.filter);
      }
      //缓存起来，页面刷新后，在获取当前过滤条件
      // window.localStorage.setItem('TPL_FILTERS', JSON.stringify(targetArr));
      return {
        ...state,
        searchFilterList: targetArr,
      };
    }
    case ACTIONS.CLEAR_SEARCH_FILTER: {
      let targetArr = state.searchFilterList.concat();
      if (targetArr.length > 0) {
        for (let index = 0; index < targetArr.length; index++) {
          const element = targetArr[index];
          if (element.key === action.filter.key) {
            targetArr.splice(index, 1);
          }
        }
      }
      return { ...state, searchFilterList: targetArr };
    }
    default:
      return state;
  }
};
